<template>
  <div class="wrapper limit">
    <slick
      ref="slick"
      class="img-slider"
      :options="slickOptions"
     
    >
      <template v-for="(img, index) in images">
        <div :key="index" class="wrap">
          <img :src="img" />
        </div>
      </template>
    </slick>
  </div>
</template>

<script>
import Slick from "vue-slick";

function importAll(r) {
  let images = {};
  r.keys().map((item, index) => {
    images[item.replace("./", "")] = r(item);
  });
  return images;
}

const images = Object.values(
  importAll(require.context("@/assets/clients", false, /\.(png|jpe?g|svg)$/))
);

// console.log(images);

export default {
  components: { Slick },

  data() {
    return {
      images: images,
      slickOptions: {
        slidesToShow: 1,
        arrows: false,
        autoplay: true,
        easing: "ease",
        draggable: false,
    autoplaySpeed: 2000,
    edgeFriction: 0,
        infinite: true,
        responsive: [
            {
            breakpoint: 9999,
            settings: {
              slidesToShow: 6,
              infinite: true
            }
          },
          
          {
            breakpoint: 1500,
            settings: {
              slidesToShow: 4,
              infinite: true
            }
          },
          {
            breakpoint: 1100,
            settings: {
              slidesToShow: 3,
            }
          },
          {
            breakpoint: 768,
            slidesToShow: 2,
          }
        ]
        // Any other options that can be got from plugin documentation
      }
    };
  },

  // All slick methods can be used too, example here
  methods: {
    next() {
      this.$refs.slick.next();
    },

    prev() {
      this.$refs.slick.prev();
    },

    reInit() {
      // Helpful if you have to deal with v-for to update dynamic lists
      this.$nextTick(() => {
        this.$refs.slick.reSlick();
      });
    },

    // Events listeners
    handleAfterChange(event, slick, currentSlide) {
      console.log("handleAfterChange", event, slick, currentSlide);
    },
    handleBeforeChange(event, slick, currentSlide, nextSlide) {
      console.log("handleBeforeChange", event, slick, currentSlide, nextSlide);
    },
    handleBreakpoint(event, slick, breakpoint) {
      console.log("handleBreakpoint", event, slick, breakpoint);
    },
    handleDestroy(event, slick) {
      console.log("handleDestroy", event, slick);
    },
    handleEdge(event, slick, direction) {
      console.log("handleEdge", event, slick, direction);
    },
    handleInit(event, slick) {
      console.log("handleInit", event, slick);
    },
    handleReInit(event, slick) {
      console.log("handleReInit", event, slick);
    },
    handleSetPosition(event, slick) {
      console.log("handleSetPosition", event, slick);
    },
    handleSwipe(event, slick, direction) {
      console.log("handleSwipe", event, slick, direction);
    },
    handleLazyLoaded(event, slick, image, imageSource) {
      console.log("handleLazyLoaded", event, slick, image, imageSource);
    },
    handleLazeLoadError(event, slick, image, imageSource) {
      console.log("handleLazeLoadError", event, slick, image, imageSource);
    }
  }
};
</script>

<style lang="scss" scoped>
@import "~slick-carousel/slick/slick.css";

.img-slider {
  padding-top: 60px;
  padding-bottom: 60px;

  img {
      opacity: 0.5;
  }
}
</style>
